// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root____aHs","row":"Node_row__2b28Z","label":"Node_label__3vdwf","footer":"Node_footer__iCJru"};